/* ==========================================================================
   AirSeat1 広告LP スクリプト
   AirSeat25用（airseat25-lp.js）とは完全に独立したファイル。
   Shopify theme assets/ に配置。テーマ側では以下で読み込む：
     <script src="{{ 'airseat1-lp.js' | asset_url }}" defer></script>

   注意：defer属性により、このスクリプトはDOM解析完了後・DOMContentLoaded
   発火前に実行されるため、DOMContentLoadedラッパーは使っていない
   （ラップすると各関数がグローバルスコープから外れ、HTML側の
   onclick="..." インラインハンドラから参照できなくなるため）。

   Meta Pixelについて：このファイルではfbq()を一切呼び出さない。
   AddToCart / InitiateCheckout / Purchase は、Shopify公式の
   「Facebook & Instagram」販売チャネルが自動計測する標準イベントに
   委ねる（二重計測を避けるため、手動実装しない）。
   ========================================================================== */

function as1TrackEvent(name, params){
  params = params || {};
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', name, params);
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
  if (
    typeof window.fbq !== 'function' &&
    typeof window.gtag !== 'function'
  ) {
    console.log('[as1-track]', name, params);
  }
}

as1TrackEvent('lp_view');


// ==========================================================================
// 50% scroll
// ==========================================================================
(function(){
  let scrolledHalf = false;

  window.addEventListener('scroll', function(){
    const scrolled =
      (window.scrollY + window.innerHeight) /
      document.body.scrollHeight;

    if(!scrolledHalf && scrolled > 0.5){
      scrolledHalf = true;
      as1TrackEvent('scroll_50');
    }
  }, { passive:true });
})();


// ==========================================================================
// sticky CTA visibility
// FVを通過している間だけ表示。
// 最終購入セクションが画面内に入ったら二重表示を避けるため非表示。
// ==========================================================================
(function(){
  const fv = document.getElementById('as1-fv');
  const purchaseSection = document.getElementById('as1-purchase');
  const stickyCta = document.getElementById('as1StickyCta');

  if(!fv || !stickyCta) return;

  let pastFv = false;
  let purchaseInView = false;

  function update(){
    stickyCta.classList.toggle(
      'show',
      pastFv && !purchaseInView
    );
  }

  const fvObserver = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      pastFv = !e.isIntersecting;
      update();
    });
  }, { threshold:0 });

  fvObserver.observe(fv);

  if(purchaseSection){
    const purchaseObserver = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        purchaseInView = e.isIntersecting;
        update();
      });
    }, { threshold:0.15 });

    purchaseObserver.observe(purchaseSection);
  }
})();


// ==========================================================================
// fade-in on scroll
// ==========================================================================
(function(){
  const items = document.querySelectorAll('.as1-fade-item');

  if(!items.length) return;

  const observer = new IntersectionObserver((entries)=>{
    entries.forEach((e, i)=>{
      if(e.isIntersecting){
        setTimeout(()=>{
          e.target.classList.add('visible');
        }, i * 80);

        observer.unobserve(e.target);
      }
    });
  }, { threshold:0.3 });

  items.forEach(el=>{
    observer.observe(el);
  });
})();


// ==========================================================================
// motion GIF / 動画
// GIFはimgタグなので自動ループ。
// videoの場合のみ画面内で再生。
// ==========================================================================
(function(){
  const video = document.querySelector(
    '.as1-motion-frame video'
  );

  if(!video) return;

  let tracked = false;

  const observer = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){

        video.play()
          .then(()=>{
            if(!tracked){
              tracked = true;

              as1TrackEvent(
                'video_play',
                { id:'as1_motion' }
              );
            }
          })
          .catch(()=>{});

      } else {

        video.pause();

      }
    });
  }, { threshold:0.5 });

  observer.observe(video);
})();


// ==========================================================================
// FAQ accordion
// ==========================================================================
function as1ToggleAccordion(head){

  const item = head.closest(
    '.as1-accordion-item'
  );

  item.classList.toggle('open');

}


// ==========================================================================
// smooth scroll
// ==========================================================================
function as1ScrollToId(id){

  const el = document.getElementById(id);

  if(el){
    el.scrollIntoView({
      behavior:'smooth'
    });
  }

}


// ==========================================================================
// 最終購入セクション
//
// ・在庫あり → 通常販売
// ・在庫0以下 + inventory_policy = continue → 予約販売
// ・在庫0以下 + deny → 売り切れ
//
// 予約商品の発送予定日は
// LPアクセス日から「カレンダー上の1か月後」
//
// 例
// 9/16 → 10/16
// 10/31 → 11/30
//
// 月末で同日が存在しない場合は翌月末日に調整。
// ==========================================================================
(function(){

  const root =
    document.getElementById(
      'as1-purchase-form'
    );

  if(!root) return;


  // ------------------------------------------------------------------------
  // Shopify variant data
  // ------------------------------------------------------------------------
  let productData;

  try {

    productData = JSON.parse(
      document.getElementById(
        'as1-product-json'
      ).textContent
    );

  } catch(e){

    console.error(
      'AirSeat1 商品データの読み込みに失敗しました',
      e
    );

    return;

  }


  // ------------------------------------------------------------------------
  // DOM
  // ------------------------------------------------------------------------
  const priceEl =
    root.querySelector(
      '.as1-purchase-price'
    );

  const stockEl =
    root.querySelector(
      '.as1-purchase-stock'
    );

  const buyBtn =
    root.querySelector(
      '.as1-buy-btn'
    );

  const errorEl =
    root.querySelector(
      '.as1-purchase-error'
    );

  const qtyValueEl =
    root.querySelector(
      '.as1-qty-value'
    );

  const optionGroups =
    root.querySelectorAll(
      '.as1-option-group'
    );

  const reservationNotice =
    document.getElementById(
      'as1ReservationNotice'
    );

  const reservationDateEl =
    document.getElementById(
      'as1ReservationDate'
    );


  // ------------------------------------------------------------------------
  // state
  // ------------------------------------------------------------------------
  let selectedOptions =
    productData[0]
      ? productData[0].options.slice()
      : [];

  let quantity = 1;


  // ------------------------------------------------------------------------
  // price format
  // ------------------------------------------------------------------------
  function formatPrice(cents){

    return '¥' +
      Math.round(
        cents / 100
      ).toLocaleString('ja-JP');

  }


  // ------------------------------------------------------------------------
  // variant finder
  // ------------------------------------------------------------------------
  function findVariant(options){

    return productData.find(v =>

      v.options.every(
        (val, idx) =>
          val === options[idx]
      )

    );

  }


  // ------------------------------------------------------------------------
  // カレンダー上の1か月後
  //
  // 例：
  // 2026/01/31 → 2026/02/28
  // 2028/01/31 → 2028/02/29
  // ------------------------------------------------------------------------
  function addOneCalendarMonthClamped(date){

    const sourceYear =
      date.getFullYear();

    const sourceMonth =
      date.getMonth();

    const sourceDay =
      date.getDate();


    const targetMonthStart =
      new Date(
        sourceYear,
        sourceMonth + 1,
        1
      );


    const targetYear =
      targetMonthStart.getFullYear();

    const targetMonth =
      targetMonthStart.getMonth();


    const lastDayOfTargetMonth =
      new Date(
        targetYear,
        targetMonth + 1,
        0
      ).getDate();


    const targetDay =
      Math.min(
        sourceDay,
        lastDayOfTargetMonth
      );


    return new Date(
      targetYear,
      targetMonth,
      targetDay
    );

  }


  // ------------------------------------------------------------------------
  // 日本語日付
  // ------------------------------------------------------------------------
  function formatJapaneseDate(date){

    return (
      date.getFullYear() +
      '年' +
      (date.getMonth() + 1) +
      '月' +
      date.getDate() +
      '日頃'
    );

  }


  // ------------------------------------------------------------------------
  // 予約発送予定日
  // ------------------------------------------------------------------------
  const reservationDateText =
    formatJapaneseDate(
      addOneCalendarMonthClamped(
        new Date()
      )
    );


  if(reservationDateEl){

    reservationDateEl.textContent =
      reservationDateText;

  }


  // ------------------------------------------------------------------------
  // 予約対象判定
  //
  // ・在庫追跡あり
  // ・inventory_quantity <= 0
  // ・inventory_policy === continue
  // ------------------------------------------------------------------------
  function isReservationVariant(variant){

    if(!variant) return false;

    return (
      variant.inventory_management != null &&
      Number(
        variant.inventory_quantity
      ) <= 0 &&
      variant.inventory_policy === 'continue'
    );

  }


  // ------------------------------------------------------------------------
  // 購入可能判定
  // ------------------------------------------------------------------------
  function isPurchasableVariant(variant){

    return (
      !!variant &&
      (
        variant.available ||
        isReservationVariant(variant)
      )
    );

  }


  // ------------------------------------------------------------------------
  // UI更新
  // ------------------------------------------------------------------------
  function updateUI(){

    const variant =
      findVariant(
        selectedOptions
      );


    // ----------------------------------------------------------------------
    // option chip state
    // ----------------------------------------------------------------------
    optionGroups.forEach(group=>{

      const optionIndex =
        parseInt(
          group.dataset.optionIndex,
          10
        );


      group
        .querySelectorAll(
          '.as1-option-chip'
        )
        .forEach(chip=>{

          const value =
            chip.dataset.value;


          chip.classList.toggle(
            'is-selected',
            selectedOptions[
              optionIndex
            ] === value
          );


          const testOptions =
            selectedOptions.slice();


          testOptions[
            optionIndex
          ] = value;


          const matching =
            productData.filter(v =>

              v.options.every(
                (val, idx) =>
                  idx === optionIndex ||
                  val ===
                    testOptions[idx]
              )

            );


          const anyPurchasable =
            matching.some(
              v =>
                isPurchasableVariant(v)
            );


          chip.disabled =
            !anyPurchasable;

        });

    });


    // ----------------------------------------------------------------------
    // 予約案内を一旦非表示
    // ----------------------------------------------------------------------
    if(reservationNotice){

      reservationNotice.hidden =
        true;

    }


    // ----------------------------------------------------------------------
    // variantあり
    // ----------------------------------------------------------------------
    if(variant){

      priceEl.textContent =
        formatPrice(
          variant.price
        );


      // --------------------------------------------------------------------
      // 予約販売
      // --------------------------------------------------------------------
      if(
        isReservationVariant(
          variant
        )
      ){

        stockEl.textContent =
          '予約販売受付中';

        stockEl.className =
          'as1-purchase-stock in';


        buyBtn.textContent =
          '予約注文する';

        buyBtn.disabled =
          false;


        if(reservationNotice){

          reservationNotice.hidden =
            false;

        }


      // --------------------------------------------------------------------
      // 通常販売
      // --------------------------------------------------------------------
      } else if(
        variant.available
      ){

        stockEl.textContent =
          '在庫あり';

        stockEl.className =
          'as1-purchase-stock in';


        buyBtn.textContent =
          'AirSeat1を購入する';

        buyBtn.disabled =
          false;


      // --------------------------------------------------------------------
      // 売り切れ
      // --------------------------------------------------------------------
      } else {

        stockEl.textContent =
          '売り切れ';

        stockEl.className =
          'as1-purchase-stock out';


        buyBtn.textContent =
          '売り切れ';

        buyBtn.disabled =
          true;

      }


    // ----------------------------------------------------------------------
    // variantなし
    // ----------------------------------------------------------------------
    } else {

      if(productData[0]){

        priceEl.textContent =
          formatPrice(
            productData[0].price
          );

      }


      stockEl.textContent =
        'この組み合わせは選択できません';

      stockEl.className =
        'as1-purchase-stock out';


      buyBtn.textContent =
        'AirSeat1を購入する';

      buyBtn.disabled =
        true;

    }


    qtyValueEl.textContent =
      quantity;

  }


  // ------------------------------------------------------------------------
  // option buttons
  // ------------------------------------------------------------------------
  optionGroups.forEach(group=>{

    const optionIndex =
      parseInt(
        group.dataset.optionIndex,
        10
      );


    group
      .querySelectorAll(
        '.as1-option-chip'
      )
      .forEach(chip=>{

        chip.addEventListener(
          'click',
          ()=>{

            if(chip.disabled){
              return;
            }


            selectedOptions[
              optionIndex
            ] =
              chip.dataset.value;


            updateUI();

          }
        );

      });

  });


  // ------------------------------------------------------------------------
  // quantity
  // ------------------------------------------------------------------------
  const qtyMinus =
    root.querySelector(
      '.as1-qty-minus'
    );

  const qtyPlus =
    root.querySelector(
      '.as1-qty-plus'
    );


  if(qtyMinus){

    qtyMinus.addEventListener(
      'click',
      ()=>{

        if(quantity > 1){

          quantity -= 1;

          updateUI();

        }

      }
    );

  }


  if(qtyPlus){

    qtyPlus.addEventListener(
      'click',
      ()=>{

        quantity += 1;

        updateUI();

      }
    );

  }


  // ------------------------------------------------------------------------
  // buy / reservation
  // ------------------------------------------------------------------------
  buyBtn.addEventListener(
    'click',
    ()=>{

      const variant =
        findVariant(
          selectedOptions
        );


      // --------------------------------------------------------------------
      // 購入不可
      // --------------------------------------------------------------------
      if(
        !isPurchasableVariant(
          variant
        )
      ){

        errorEl.textContent =
          'この組み合わせは現在ご購入いただけません。別のオプションをお試しください。';

        errorEl.classList.add(
          'show'
        );

        return;

      }


      const reservation =
        isReservationVariant(
          variant
        );


      errorEl.classList.remove(
        'show'
      );


      buyBtn.disabled =
        true;


      const originalText =
        buyBtn.textContent;


      buyBtn.textContent =
        '処理中…';


      as1TrackEvent(
        'cta_click',
        {
          loc:'as1_purchase',
          order_type:
            reservation
              ? 'reservation'
              : 'normal'
        }
      );


      // --------------------------------------------------------------------
      // Shopify cart item
      // --------------------------------------------------------------------
      const cartItem = {

        id: variant.id,

        quantity: quantity

      };


      // --------------------------------------------------------------------
      // 予約注文の場合だけline item property追加
      // --------------------------------------------------------------------
      if(reservation){

        cartItem.properties = {

          '予約商品':
            reservationDateText +
            '発送予定'

        };

      }


      // --------------------------------------------------------------------
      // AJAX Cart
      // --------------------------------------------------------------------
      fetch(
        '/cart/add.js',
        {

          method:'POST',

          headers:{
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body:
            JSON.stringify(
              cartItem
            )

        }
      )


      .then(res=>{

        if(!res.ok){

          throw new Error(
            'cart add failed'
          );

        }


        return res.json();

      })


      .then(()=>{

        as1TrackEvent(
          'product_page_transition',
          {
            loc:
              'as1_purchase_checkout',

            order_type:
              reservation
                ? 'reservation'
                : 'normal'
          }
        );


        window.location.href =
          '/checkout';

      })


      .catch(err=>{

        console.error(
          'AirSeat1 カート追加エラー',
          err
        );


        errorEl.textContent =
          'カートへの追加に失敗しました。時間をおいて再度お試しください。';


        errorEl.classList.add(
          'show'
        );


        buyBtn.disabled =
          false;


        buyBtn.textContent =
          originalText;

      });

    }
  );


  // ------------------------------------------------------------------------
  // initial render
  // ------------------------------------------------------------------------
  updateUI();

})();